import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

let cache: Record<string, string> | null = null;
let inflight: Promise<Record<string, string>> | null = null;

async function load(): Promise<Record<string, string>> {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = (async () => {
    const { data, error } = await (supabase as unknown as {
      from: (t: string) => { select: (q: string) => Promise<{ data: { id: string; name: string }[] | null; error: unknown }> };
    }).from("substances").select("id,name");
    if (error) throw error;
    const map: Record<string, string> = {};
    for (const r of data ?? []) map[r.name] = r.id;
    cache = map;
    return map;
  })();
  return inflight;
}

export function useSubstanceIdMap() {
  const [map, setMap] = useState<Record<string, string> | null>(cache);
  useEffect(() => {
    if (cache) return;
    load().then(setMap).catch(() => setMap({}));
  }, []);
  return map;
}
